import {
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  Typography,
} from "@material-ui/core";
import { format } from "date-fns";
import React, { useEffect, useState } from "react";
import CustomDialogTdsat from "./CustomDialogTdsat";
import { getStatus } from "./TdsatContainer";
import PayBharatKosh from "./components/PayBharatKosh";
import UploadFileTdsat from "./components/UploadFileTdsat";
import instance from "api/globalaxios";
import { createReciepts } from "./ApplicationFillingForm";
import Swal from "sweetalert2";
import { getType, getUploadedFileUrl } from "./CaseDetailsTDSAT";
import PayStockHoldings from "./components/PayStockHoldings";

function getUploadType(type) {
  switch(type) {
    case 'main_cases':
      return 'MainCase';
    case 'applications':
      return 'Application';
    case 'documents':
      return 'Document';
    case 'caveats':
      return 'Caveat';
    case 'court_fees':
      return 'courtfees';
    default:
      return 'Unknown Type';
  }
}

function getRecieptContentType(type) {
  switch(type) {
    case 'main_cases':
      return 'main_case';
    case 'applications':
      return 'application';
    case 'documents':
      return 'document';
    case 'caveats':
      return 'caveat';
    case 'court_fees':
      return 'court_fees';
    default:
      return 'Unknown Type';
  }
}

export async function getDeficitCourtFee(type, defectId) {
  return await instance({
    method: "get",
    url: `/tdsat/financial-check/deficit-court-fees/?${type}=${defectId}`,
  });
}

function MainCaseRow({
  classes,
  dispute,
  index,
  spacing,
  IS_ADMIN,
  handleClickOnRow,
  activeTabMain,
  activeTab,
  page,
  pageSize,
  updateDisputeDefects
}) {
  const [open, setOpen] = useState(false);
  const [eRecieptData, setERecieptData] = useState({content_type: getUploadType(dispute?.type)});
  const [errors,setErrors] = useState({})
  const [deficitFeeData, setDeficitFeeData] = useState([]);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (open && dispute?.is_defective && !dispute?.is_payment_complete ) {
      async function fetchDeficitCourtFee() {
        try {
          const response = await getDeficitCourtFee(getRecieptContentType(dispute?.type), dispute?.id);
          setDeficitFeeData(response.data);
        } catch (error) {
          console.error("Error fetching deficit court fee:", error);
        }
      }
      fetchDeficitCourtFee();
    }
  }, [open, dispute?.id]);

  const data = (activeTabMain === 'court_fees') ? [
    (pageSize * (page - 1) + (index + 1)),
    dispute?.in_the_name_of,
    dispute?.dd_or_fdr_no,
    dispute?.dd_or_fdr_amount,
    dispute?.bank_and_branch_details,
    format(new Date(dispute?.case_creation_date_time), "dd/MM/y"),
    IS_ADMIN ? (
      <div style={{backgroundColor:'aliceblue'}}>{getStatus(dispute?.current_step, dispute?.is_payment_complete)}</div>
    ) : activeTab === "scrutiny" ? (
      "Pending"
    ) : (
      "Under Objection"
    ),
    ...(activeTab === "defective") ? [
      <IconButton
        color="primary"
        size="small"
        style={{ padding: "5px 10px" }}
        onClick={handleOpen}
      >
        {dispute?.defects?.length}
      </IconButton>
    ] : []
  ] : [
    (pageSize * (page - 1) + (index + 1)),
    dispute.diary_number,
    dispute.case_type_new,
    dispute.name,
    format(new Date(dispute.case_creation_date_time), "dd/MM/y"),
    IS_ADMIN ? (
      <div style={{backgroundColor:'aliceblue'}}>{getStatus(dispute?.current_step, dispute?.is_payment_complete)}</div>
    ) : activeTab === "scrutiny" ? (
      "Pending"
    ) : (
      "Under Objection"
    ),
    ...(activeTab === "defective") ? [
      <IconButton
        color="primary"
        size="small"
        style={{ padding: "5px 10px" }}
        onClick={handleOpen}
      >
        {dispute?.defects?.length}
      </IconButton>
    ] : []
  ];

  function handleModalDefect(){
    const data = {
      ...eRecieptData,
      ...(deficitFeeData?.type === 'StockHolding Payment' ? {
        stock_holding_amount_payable: deficitFeeData?.[deficitFeeData.length - 1]?.amount,
      } : {
        amount_payable: deficitFeeData?.[deficitFeeData.length - 1]?.amount,
      })
    }
    if(dispute?.is_defective && !dispute?.is_payment_complete){
      createReciepts(data)
      .then((res)=>{
        Swal.fire({
          title: "Defect",
          text: "Rectified Successfully",
          icon: "success"
        });
        updateDisputeDefects(dispute);
        setOpen(false);
      })
      .catch((error)=>{
        if(error?.response?.status === 400 && error?.response?.data?.receipt_number){
          setErrors((prev)=>{            
            return {
              ...prev,
              receipt_number: 'Court fee receipt with this receipt number already exists.',
              stock_holding_receipt_number: 'Court fee receipt with this receipt number already exists.',
            }
          })
        }

      })
    }
    if(dispute?.is_defective && dispute?.is_payment_complete){ 
      Swal.fire({
        title: "Defect",
        text: "Rectified Successfully",
        icon: "success"
      });
      updateDisputeDefects(dispute);
      setOpen(false);
    }
    
  }

  const handleViewDefectMemo = () => {
    if(dispute?.defect_file_id){
      getUploadedFileUrl(dispute?.id, getType(dispute?.type), dispute?.defect_file_id).then((res) => {
        const url = res?.data?.url;
        if (url) {
          const newTab = window.open();
          newTab.location.href = url;
        }
      })
    }
  };

  return (
    <>
      <Box key={index} className={classes.valuePaper} onClick={IS_ADMIN ? () => handleClickOnRow(dispute.id, activeTabMain) : ''}>
        <Grid key={index} container spacing={2} justifyContent="flex-start">
          {data.map((item, index) => {
            return (
              <Grid key={index} item xs sm={spacing[index]}>
                <Typography className={classes.tableRowValue}>
                  {item}
                </Typography>
              </Grid>
            );
          })}
        </Grid>
      </Box>
      <CustomDialogTdsat open={open} onClose={handleClose} title="View Defects">
        <div style={{display:'flex', justifyContent:'space-between', alignItems:'baseline'}}>
          <Typography className={classes.defectheading}>Defects</Typography>
          {(dispute?.is_defective && dispute?.is_payment_complete) && (
            <Typography color="primary" style={{textDecoration:'underline', textTransform:'uppercase', cursor:'pointer'}}><a style={{color:'#4A3BFF'}} onClick={handleViewDefectMemo}>View Defect Memo</a></Typography> 
          )}
        </div>
        <Box className={classes.defectsContainer}>
          {dispute.defects.map((defect, index) => (
            <>
              <Typography className={classes.defectitemheading}>
                Defect {index + 1}: {defect.heading}
              </Typography>
              <Typography className={classes.defectitemdescription}>
                {defect.description}
              </Typography>
              {index < dispute.defects.length - 1 && (
                <Box style={{ margin: "10px 0" }}>
                  <Divider />
                </Box>
              )}
            </>
          ))}
        </Box>
        <Box mt={1}>
          {(dispute?.is_defective && !dispute?.is_payment_complete) && (
            deficitFeeData?.type === 'StockHolding Payment' ? (
              <PayStockHoldings
                classes={classes}
                errors={errors}
                amount={deficitFeeData?.[deficitFeeData.length - 1]?.amount}
                setStockHoldingsERecieptData={setERecieptData}
                stockHoldingsERecieptData={eRecieptData}
                applicationResponse={dispute}
              />
            ) : (
              <PayBharatKosh
                classes={classes}
                amount={deficitFeeData?.[deficitFeeData.length - 1]?.amount}
                errors={errors}
                setERecieptData ={setERecieptData} 
                eReceiptData={eRecieptData}
                applicationResponse={dispute}
              />
            )
          )}
          {dispute?.is_defective && dispute?.is_payment_complete &&
            <UploadFileTdsat
              classes={classes} 
              // formData={formData}
              // handleInputChange={handleInputChange}
              // setFormData={setFormData}
              applicationResponse={dispute}
              uploadType={getUploadType(dispute?.type)}
              errors={errors}
              isAgreeNeeded={false}
            />
          }
        </Box>
        <Box mt={1}>
          <Button variant="contained" color="primary" onClick={handleModalDefect}>Submit</Button>
        </Box>
      </CustomDialogTdsat>
    </>
  );
}

export default MainCaseRow;
